import { render } from "./FamilyMemberComponent.vue?vue&type=template&id=1ec8ae35&ts=true"
import script from "./FamilyMemberComponent?vue&type=script&lang=ts"
export * from "./FamilyMemberComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__